export const onlyNumbersRegex = /^\d*(\.?\d{1,5})?$/;
export const negativeNumbersRegex = /^-?\d*(\.?\d{1,5})?$/;
